import { createContext } from 'react';

export const ToggleContainerContext = createContext({
  close: () => {},
  isOpened: false,
});

export const ToggleContainerConsumer = ToggleContainerContext.Consumer;
